import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
  standalone: false
})
export class StatusBarComponent {
  @Input() decision: string = '';
  @Input() motifRefus?: string;
  @Input() motifAbandon?: string;

  get statusClass() {
    return {
      'status-refused': this.decision === 'Refusée',
      'status-accepted': this.decision === 'Acceptée',
      'status-partially-accepted': this.decision === 'Partiellement acceptée',
      'status-abandoned': this.decision === 'Abandon',
      'status-waiting': this.decision === 'En attente' || this.decision === ''
    };
  }

  get displayedStatus() {
    return this.decision || 'En attente';
  }

  get statusReason() {
    if (this.decision === 'Refusée') return this.motifRefus;
    if (this.decision === 'Abandon') return this.motifAbandon;
    return null;
  }
}
